import React from 'react'
import { InfoSheet, useInfoSheet, IconButton } from '@fs/zion-ui'
import { ControlSettingsAdjust } from '@fs/zion-icon'
import { useQueryParams } from '@fs/zion-router'
import { css } from '@linaria/core'
import DynamicLinksOverrideForm from './OverrideForm'

const spacingCss = css`
  display: inline-block;
  margin-inline-start: 0px;
  margin-inline-end: 8px;
`

export default function DynamicLinksOverride() {
  const infoSheet = useInfoSheet()
  const { query } = useQueryParams()

  if (typeof query.override === 'undefined') {
    return null
  }

  return (
    <>
      <div className={spacingCss}>
        <IconButton
          title="Footer Links Override"
          data-test-id="footer_info_sheet_button"
          Icon={ControlSettingsAdjust}
          onClick={infoSheet.handleClick}
        />
      </div>
      <InfoSheet {...infoSheet} title="Footer Links Override" size="lg">
        <DynamicLinksOverrideForm />
      </InfoSheet>
    </>
  )
}
